import React, { useEffect } from "react";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import { headers } from "../utils/utils"

const NotificationComponent = ({ updateTicketStatus, setTicketStatus,board}) => {
  useEffect(() => {

  
    console.log("▶️ Report closed — connecting socket");
    const socket = new SockJS(process.env.REACT_APP_TICKET_SERVER + "/ws"); // Use SockJS for compatibility
    const client = new Client({
      webSocketFactory: () => socket,
      onConnect: () => {
        console.log("✅ Connected to WebSocket");
        client.subscribe("/topic/newTicket?boardId="+board, (message) => {
          const reportOpen =
            localStorage.getItem("REPORT_OPEN") === "true";

          if (reportOpen) {
            console.log("⏸ Report open in another tab — skipping update");
            return;
          }
          console.log("📩 New Ticket: ", message.body);

          fetchTicketDetails(message.body);
        });
      },
      onStompError: (frame) => {
        console.error("❌ WebSocket Error: ", frame);
      },
    });

    client.activate();

    return () => {
      client.deactivate();
    };
  }, []);

  const fetchTicketDetails = async (id) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_TICKET_SERVER}/ticket/show/${id}`,
        {
          method: "GET",
          headers: headers(),
        }
      );
      const updatedTicket = await response.json();

      setTicketStatus((prevStatus) =>
        prevStatus.map((status) => ({
          ...status,
          ticketList: status.ticketList.filter(
            (ticket) => ticket.id !== updatedTicket.id,
          ),
        })),
      );
      if (updatedTicket.archived != true)
        updateTicketStatus(updatedTicket)

    } catch (error) {
      console.error("❌ Error fetching ticket:", error);
    }
  };


};

export default NotificationComponent;
